import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import { IGetGigDaysParams, IGigDay } from '@network/models/gig-day.model'

export class GigDaysApi {
  constructor(private axios: AxiosService) {}

  getGigDays = async (params?: IGetGigDaysParams) => {
    const response = await this.axios.get<IPayload<IGigDay[]>>(
      Endpoints.getGigDays,
      params,
    )
    return response
  }
}
